import {
    Row,
    Col,
    Typography,
    Spin,
    notification,
    Divider
} from "antd"
import { createSearchModule } from "@/modules/search";
import { useCallback, useEffect, useMemo, useState } from "react";
import SearchDevices from "./SearchDevices";
import SearchBrands from "./SearchBrands";
import SearchModels from "./SearchModels";
import SearchRepairs from "./SearchRepairs";
import { createSelector } from "reselect";
import { useSelector } from "react-redux";
import Button from "../ui/Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faArrowRight } from "@fortawesome/free-solid-svg-icons";
import styled from "styled-components";
import { fetchShopReparations, selectRepairModule } from "./modules";
import SectionHeader from "../common/SectionHeader";

const StyledBackText = styled.span`
    display: inline-flex;
    align-items: center;
    font-size: 24px;
    line-height: 24px; 
    // color: #707070;
    font-weight: 700;
    // text-transform: uppercase;
    margin-left: ${props => props.showBack ? '16px' : '0'};
`
const StyledBack = styled.div`
    display: flex;
    margin: 0 0 0 0;
    .back-icon{
        paddin: 0;
        margin:0;
        width: 18px;
        height: 18px;
    }
    .back-button{
        display: flex;
        align-items: center;
        justify-content: center;
        min-width: 32px;
        max-width: 32px;
        min-height:32px;
        max-height: 32px;
        font-size: 16px;
    }
`
const StyledRepairsStep = styled.div`
    
`
const StyledColor = styled.div`
    display: flex;
    gap: 12px;
    margin-top: 12px;
    padding: 12px;
    border: 1px solid #C0C0C0;
    border-radius: 8px;
    background-color: ${({ isSelected }) => isSelected ? 'var(--primary-main-color)' : '#FAFAFA'};
    .color-code {
        display: inline-flex;
        border-radius: 4px;
        width:24px;
        height:24px;
    }
    .color-name {
        display: inline-flex;
        font-weight: 500;
        font-size: 16px;
        line-height: 150%;
        color: #707070;
    }
    .color-name.selected {
        color: #FFFFFF;
    }
`
const SEARCH_DATA_STEPS = {
    4: {
        title: 'Selecteer reparatie',
        searchPlaceholder: "Search repairs...",
        showBack: true,
        showNext: true,
    },
    3: {
        title: 'Selecteer model',
        searchPlaceholder: "Zoek model, merk...",
        showBack: true,
        showNext: false,
    },
    2: {
        title: 'Selecteer merk',
        searchPlaceholder: "Search brands...",
        showBack: true,
        showNext: false,
    },
    1: {
        title: 'Selecteer apparaat',
        searchPlaceholder: "Search devices...",
        showBack: false,
        showNext: false,
    },
}

const Back = ({ onBack, module, title }) => {
    const { step } = useSelector(selectRepairModule.selector)
    const [backTitle, setBackTitle] = useState()
    const [back, setBack] = useState(false)
    const showBack = SEARCH_DATA_STEPS[step]?.showBack

    useEffect(() => {
        // console.log('go back')
        selectRepairModule.updateGoBack(back)
        module.updateParams({ isGoBack: back })

        if (back) {
            onBack && onBack()
            setBack(false)
        }
        setBackTitle(title || SEARCH_DATA_STEPS[step].title)
    }, [back, step, title])
    // if (!showBack) {
    //     return <div></div>
    // }
    return <StyledBack>
        {showBack && <Button className="back-button"
            onClick={(e) => {
                e.preventDefault();
                setBack(true)
            }}><FontAwesomeIcon icon={faArrowLeft} className="back-icon" /></Button>
        }
        <StyledBackText showBack={showBack}>{backTitle}</StyledBackText>
    </StyledBack>
}

const StepWrapper = ({ step, crtStep, onNext, showNext, children }) => {
    if (crtStep !== step) {
        return null
    }
    // console.log(`Rendering step ${crtStep}...`)
    return (
        <Row type="flex" gutter={32}>
            <Col span={24}>
                {children}
            </Col>
        </Row>
    )
}


const searchModelSelecteItems = createSelector(
    (state) => state?.searchData?.searchDevices?.selectedItem,
    (state) => state?.searchData?.searchBrands?.selectedItem,
    (state) => state?.searchData?.searchModels?.selectedItem,
    (state) => state?.searchData?.searchRepairs?.selectedItem,
    (state) => state?.searchData?.searchModelsInline?.selectedItem,
    (selectedDevice, selectedBrand, selectedModel, selectedRepair, selectedModelInline) => {
        return {
            selectedDevice,
            selectedBrand,
            selectedModel,
            selectedRepair,
            selectedModelInline,
        }
    }
)

const SelectColor = ({ dataModule, modelSelector }) => {
    const [colors, setColors] = useState()
    const { rmodel } = useSelector(modelSelector)
    const [selectedColor, setSelectedColor] = useState()
    useEffect(() => {
        async function loadData() {
            const colors = await dataModule.fetchColors()
            // console.log(colors)
            Array.isArray(colors) && setColors(colors)
        }
        loadData()
    }, [])
    const handleSelect = ((color) => {
        // console.log(color)
        const params = dataModule.getParams() || {}
        const newParams = {
            ...params,
            color: color.id
        }
        dataModule.updateParams(newParams)

        setSelectedColor(color)
    })
    const modelColors = rmodel && colors && colors?.filter(c => rmodel.colors?.includes(c.id))
    return modelColors && modelColors.length > 0 && <>
        <SectionHeader title="Kies een kleur" />
        <Row type="flex" gutter={16}>
            {modelColors.map(color => {
                const isSelected = selectedColor && selectedColor.id === color.id
                const selectClass = isSelected ? 'selected' : '';

                return <Col span={12} key={color.id}>
                    <StyledColor className="color" isSelected={isSelected} onClick={(e) => {
                        handleSelect(color)
                    }}>
                        <div className={`color-code ${selectClass}`} style={{ backgroundColor: `${color.ui_code}` }} />
                        <span className={`color-name ${selectClass}`} >{color.name}</span>
                    </StyledColor>
                </Col>

            })}
        </Row></>

}
const SearchRepairsStep = ({ searchModule, searchPlaceholder, modelSelector, dataModule }) => {
    return <StyledRepairsStep>
        <SelectColor dataModule={dataModule} modelSelector={modelSelector} />
        <SectionHeader title="Reparaties" />
        <SearchRepairs searchModule={searchModule} searchPlaceholder={searchPlaceholder} />
    </StyledRepairsStep>
}

const SelectRepair = ({ onFinish, dataModule, modelSelector }) => {
    const [step, setStep] = useState(1)
    const [showNext, setShowNext] = useState(false)
    const searchDevicesModule = createSearchModule('searchDevices', dataModule.fetchSearchDevices)
    const searchBrandsModule = createSearchModule('searchBrands', dataModule.fetchSearchBrands)
    const searchModelsModule = createSearchModule('searchModels', dataModule.fetchSearchModels)
    const searchRepairsModule = createSearchModule('searchRepairs', dataModule.fetchSearchRepairs)
    const { selectedDevice, selectedBrand, selectedModel, selectedRepair, selectedModelInline } = useSelector(searchModelSelecteItems)
    const { isGoBack } = useSelector(selectRepairModule.selector)

    useEffect(() => {
        selectRepairModule.updateStep(step)
    }, [step])
    async function loadSelectedModel(model) {
        const fetch = (step === 4) ? true : false

        setStep(4)
        searchRepairsModule.actions.updateIsLoading(true)
        searchRepairsModule.actions.updateSelectedItem(null)
        const newParams = {
            device: model.device?.id,
            brand: model.brand?.id,
            model: model.id,
            reparation: null,
            color: null
        }
        // console.log(newParams)
        dataModule.updateParams(newParams)
        if (fetch) {
            await searchRepairsModule.actions.fetch_results()
        }
        setShowNext(false)
    }
    useEffect(() => {
        // console.log('selected inline model...')
        if (selectedModelInline) {
            // console.log(selectedModelInline)
            loadSelectedModel(selectedModelInline)
        }
    }, [selectedModelInline])
    useEffect(() => {
        (async () => {
            const queryString = window.location.search;
            const urlParams = new URLSearchParams(queryString);
            const modelId = urlParams.get('model')
            if (modelId) {
                console.log(`url model=${modelId}`)
                const searchModelsInline = createSearchModule('searchModelsInline', dataModule.fetchInlineModels)
                const data = await searchModelsInline.actions.fetch_results()
                const selectedModel = data.find(item => item.id === parseInt(modelId))
                if (selectedModel) {
                    searchModelsInline.actions.updateSelectedItem(selectedModel)
                }
            }
        })()
    }, [])

    useEffect(() => {
        // console.log(`selected device ${selectedDevice}`)
        if (selectedDevice && step !== 2) {
            dataModule.updateParams({ device: selectedDevice?.id })
            searchDevicesModule.actions.updateDefaultImage(selectedDevice.image)
            searchBrandsModule.actions.updateDefaultImage(selectedDevice.image)
            searchModelsModule.actions.updateDefaultImage(selectedDevice.image)
            setStep(2)
        }
    }, [selectedDevice])
    useEffect(() => {
        async function loadBrandRepairs() {

            const params = dataModule.getParams()
            console.log(params)
            const { shop, device } = params

            if (shop && device && selectedBrand) {
                // console.log(shop?.id, device, selectedBrand?.id, -1)
                const shopRepairs = await fetchShopReparations(shop?.id, device, selectedBrand?.id, -1)
                if (shopRepairs && shopRepairs.length > 0) {
                    console.log(shopRepairs)
                    dataModule.updateParams({ brand: selectedBrand?.id, model: -1 })
                    setStep(4)
                } else {
                    dataModule.updateParams({ brand: selectedBrand?.id })
                    setStep(3)
                }
            }
        }
        // console.log(`selected brand ${selectedBrand}`)
        if (selectedBrand && step !== 3) {
            loadBrandRepairs()
        }

    }, [selectedBrand])
    useEffect(() => {
        // console.log(`selected model ${selectedModel}`)
        if (selectedModel && step !== 4) {
            dataModule.updateParams({ model: selectedModel?.id })
            setStep(4)
        }
    }, [selectedModel])

    useEffect(() => {
        // console.log(`selected model ${selectedRepair}`)
        if (selectedRepair && step === 4) {
            dataModule.updateParams({ reparation: selectedRepair?.id })
            setShowNext(true)
        }
    }, [selectedRepair])

    useEffect(() => {
        if (isGoBack) {
            const crtStep = step
            console.log(`go back from step ${crtStep}`)
            if (crtStep > 1) {
                setStep(crtStep - 1)
            }
            if (crtStep === 4) {
                searchRepairsModule.actions.updateSelectedItem(null)
                setShowNext(false)
                const params = dataModule.getParams()
                if (params && params.model === -1) {
                    setStep(2)
                }
            }
            dataModule.updateParams({ isGoBack: true, color: null })
        }
    }, [isGoBack])

    const handleNext = (rstep) => {
        // console.log(`on next triggered for step ${rstep}`)
        if (rstep < 4) {
            setStep(rstep + 1)
        }
        if (rstep === 4) {
            // console.log('last step next...')
            onFinish()
        }
    };
    // console.log(`select repair step parent ${step}`)

    return <>
        <Row type="flex" gutter={0}>
            <Col span={24}>
                <StepWrapper step={1} crtStep={step}
                    onNext={handleNext}>
                    <SearchDevices searchModule={searchDevicesModule} searchPlaceholder={SEARCH_DATA_STEPS[1]?.searchPlaceholder} />
                </StepWrapper>
                <StepWrapper step={2} crtStep={step}
                    onNext={handleNext}>
                    <SearchBrands searchModule={searchBrandsModule} searchPlaceholder={SEARCH_DATA_STEPS[2]?.searchPlaceholder} />
                </StepWrapper>
                <StepWrapper step={3} crtStep={step}
                    onNext={handleNext}>
                    <SearchModels searchModule={searchModelsModule} searchPlaceholder={SEARCH_DATA_STEPS[3]?.searchPlaceholder} />
                </StepWrapper>
                <StepWrapper step={4} crtStep={step}
                    onNext={handleNext}
                    showNext={showNext}>
                    <SearchRepairsStep searchModule={searchRepairsModule}
                        searchPlaceholder={SEARCH_DATA_STEPS[4]?.searchPlaceholder}
                        modelSelector={modelSelector}
                        dataModule={dataModule} />
                </StepWrapper>
            </Col>
        </Row>
    </>
}
export default SelectRepair;
export { Back }
